"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        // closest() instead of className.indexOf: className is not a string on the SVG bag icon,
        // which threw and let the link fall through to /cart
        if ($(e.target).closest('.checkout-button').length) {
          return true;
        } else {
          this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
          e.preventDefault();
          Shopify.theme.jsAjaxCart.showDrawer();
          return false;
        }
      });
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      var itemKey = $(this).data('cart-item-key');
      Shopify.theme.jsAjaxCart.removeFromCart(itemKey);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(itemKey);
      }

      return false;
    });
    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
    $(document).on('click', '.ap-cart__section-toggle', function () {
      var $section = $(this).closest('[data-ap-cart-section]');
      var isOpen = !$section.hasClass('is-collapsed');
      Shopify.theme.jsAjaxCart.sectionState[$section.data('ap-cart-section')] = !isOpen;
      Shopify.theme.jsAjaxCart.applySectionState();
    });
    $(document).on('click', '[data-ap-cart-add]', function (e) {
      e.preventDefault();
      var $button = $(this);
      var data = {
        id: $button.data('ap-cart-add'),
        quantity: 1
      };

      if ($button.is('[data-ap-cart-gift]')) {
        // Hidden property so the drawer can recognise (and auto-remove) the gift line
        data.properties = {
          _gift: 'Yes'
        };
      }

      $button.attr('disabled', 'disabled');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function success() {
          Shopify.theme.jsAjaxCart.updateView();
        },
        error: function error() {
          $button.removeAttr('disabled');
        }
      });
    });
  },
  // Open (true) / closed (false) state of the drawer accordions, kept across re-renders
  sectionState: {},
  applySectionState: function applySectionState() {
    var state = this.sectionState;
    $('[data-ap-cart-section]').each(function () {
      var isOpen = state[$(this).data('ap-cart-section')] !== false;
      $(this).toggleClass('is-collapsed', !isOpen);
      $(this).find('.ap-cart__section-toggle').attr('aria-expanded', isOpen);
    });
  },
  // Runs after every drawer render
  afterRender: function afterRender() {
    this.applySectionState();
    this.updateDelivery();
    this.updateGift();
  },
  // Converts an amount (minor units) to the cart currency. Returns null when it can't be converted.
  convertAmount: function convertAmount(amount, fromCurrency) {
    var $scroll = $('.ap-cart__scroll');
    var cartCurrency = $scroll.data('cart-currency');
    var shopCurrency = $scroll.data('shop-currency');
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate) || 1;
    if (fromCurrency === cartCurrency) return amount;
    if (fromCurrency === shopCurrency) return Math.ceil(amount * rate);
    return null;
  },
  formatAmount: function formatAmount(amount) {
    var currency = $('.ap-cart__scroll').data('cart-currency');
    var digits = amount % 100 === 0 ? 0 : 2;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(amount / 100);
    } catch (error) {
      return (amount / 100).toFixed(digits) + ' ' + currency;
    }
  },
  updateDelivery: function updateDelivery() {
    var $delivery = $('[data-ap-cart-delivery]');
    if (!$delivery.length) return;
    var threshold = this.convertAmount(parseInt($delivery.data('threshold'), 10), $delivery.data('threshold-currency'));
    var total = parseInt($delivery.data('total'), 10);

    if (!threshold) {
      $delivery.attr('hidden', true);
      return;
    }

    var remaining = threshold - total;
    var progress = Math.min(100, Math.max(0, total / threshold * 100));
    var text = remaining > 0 ? String($delivery.data('text')).replace('[amount]', this.formatAmount(remaining)) : $delivery.data('success-text');
    $delivery.find('[data-ap-cart-delivery-text]').text(text);
    $delivery.find('[data-ap-cart-delivery-bar]').css('width', progress + '%');
    $delivery.removeAttr('hidden');
  },
  updateGift: function updateGift() {
    var $gift = $('[data-ap-cart-gift-box]');
    if (!$gift.length) return;
    var threshold = this.convertAmount(parseInt($gift.data('threshold'), 10), $('.ap-cart__scroll').data('shop-currency'));
    var qualifies = threshold !== null && parseInt($gift.data('total'), 10) >= threshold;
    var giftLine = $gift.data('gift-line');

    if (giftLine && !qualifies && !this.removingGift) {
      // Bag dropped below the spend amount: take the gift back out
      this.removingGift = true;
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: giftLine,
          quantity: 0
        },
        dataType: 'json',
        complete: function complete() {
          Shopify.theme.jsAjaxCart.removingGift = false;
          Shopify.theme.jsAjaxCart.updateView();
        }
      });
      return;
    }

    // Only show the gift once the bag reaches the spend amount
    $gift.closest('[data-ap-cart-section]').prop('hidden', !qualifies);
    $gift.find('button[data-ap-cart-gift]').prop('disabled', !qualifies);
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    $el.hover(function () {
      $el.addClass('show-mini-cart');
    }, function () {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header


      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($('.mobile-header').height());

      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $('.mobile-header .theme-ajax-cart').css({
        height: "calc(100vh - ".concat(mobileHeaderHeight + announcementHeight, "px)")
      });
    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('html').addClass('ap-cart-open');
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('html').removeClass('ap-cart-open');
  },
  removeFromCart: function removeFromCart(itemKey, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + itemKey,
      dataType: 'json',
      success: function success(cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref) {
      var html = _ref.html,
          options = _ref.options;
      $('[data-ajax-cart-content]').html(html.content);
      Shopify.theme.jsAjaxCart.afterRender();

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    this.toggleMiniCart();
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref2) {
      var html = _ref2.html,
          options = _ref2.options;
      $('.mobile-header [data-ajax-cart-content]').html(html.content);

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function success(product) {
        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax((_$$ajax = {
            dataType: "json",
            async: false,
            cache: false
          }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
            var cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);
          }), _$$ajax));
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('span').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
      }
    });
  },
  updateView: function updateView() {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref3) {
      var html = _ref3.html,
          options = _ref3.options;

      if (Shopify.theme.jsAjaxCart.cart_action == 'drawer') {
        // Re-render the whole drawer so delivery progress, gift and recommendations stay in sync
        var scrollTop = $('.ap-cart__scroll').scrollTop();
        $('[data-ajax-cart-content]').html(html.content);
        $('.ap-cart__scroll').scrollTop(scrollTop);
        Shopify.theme.jsAjaxCart.afterRender();
        $('[data-ajax-cart-trigger]').toggleClass('has-cart-count', options.item_count > 0);
        $('[data-bind="itemCount"]').text(options.item_count);
      } else if (options.item_count > 0) {
        var itemList = $(html.content).find('.ajax-cart__list');
        var savings = $(html.content).find('.ajax-cart__savings');
        var subtotal = $(html.content).find('.ajax-cart__subtotal');
        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__savings').replaceWith(savings);
        $('.ajax-cart__subtotal').replaceWith(subtotal);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () {// some error handling
    });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
};
